export default {
  CHECKIN_REQUEST: "wci/CHECKIN_REQUEST",
  CHECKIN_RESPONSE: "wci/CHECKIN_RESPONSE",
  BOOKING_REQUEST:  "wci/BOOKING_REQUEST",
  BOOKING_RESPONSE: "wci/BOOKING_RESPONSE",
}